import { Datepicker } from "vanillajs-datepicker";

export default class DatePicker {

    constructor() {
        this.init();
    }

    init() {

        const datePicker = document.querySelectorAll(".js-date-picker");

        if (datePicker.length < 1) {
            return;
        }

        for (let i = 0; i < datePicker.length; i++) {

            const datepicker = new Datepicker(datePicker[i],{
                format: 'dd/mm/yyyy',
            });

        }

    }

}
